import client from './client'

export function fetchTrackCompletions({ availableForTrip = false } = {}) {
  const params = {}
  if (availableForTrip) params.available_for_trip = '1'
  return client.get('/api/v1/user/track_completions', { params })
}
